module.exports = function getResource(label, vars = []) {
    let resources = {
        minimum: 'Min.',
        characters: 'caractères'
    };

    return resources[label];
};
